import { api, ApiResponse } from './api'

/**
 * H4 del roadmap (Fase B #5): login antes de compartir el dashboard con el
 * equipo (Alfonso/Elizabeth/Sylwester). Ampliado con roles (admin/operator)
 * a petición del usuario: "administrador" gestiona usuarios, "operador"
 * solo usa el dashboard y cambia su propia contraseña.
 */

export type UserRole = 'admin' | 'operator'

export interface AuthUser {
  id: number
  email: string
  name: string | null
  role: UserRole
}

export const login = async (email: string, password: string): Promise<ApiResponse<{ token: string; user: AuthUser }>> => {
  const response = await api.post<ApiResponse<{ token: string; user: AuthUser }>>('/auth/login', { email, password })
  return response.data
}

export const getMe = async (): Promise<ApiResponse<AuthUser>> => {
  const response = await api.get<ApiResponse<AuthUser>>('/auth/me')
  return response.data
}

export const changePassword = async (currentPassword: string, newPassword: string): Promise<ApiResponse<null>> => {
  const response = await api.put<ApiResponse<null>>('/auth/change-password', { currentPassword, newPassword })
  return response.data
}

// Los siguientes 4 solo funcionan si quien llama es "admin" (requireAdmin
// en el backend) — el panel de administrador en Users.tsx ya restringe el
// acceso a la página entera por rol, pero el backend es quien de verdad
// lo hace cumplir.

export const listUsers = async (): Promise<ApiResponse<AuthUser[]>> => {
  const response = await api.get<ApiResponse<AuthUser[]>>('/auth/users')
  return response.data
}

export const createUser = async (
  email: string,
  password: string,
  name?: string,
  role?: UserRole
): Promise<ApiResponse<AuthUser>> => {
  const response = await api.post<ApiResponse<AuthUser>>('/auth/users', { email, password, name, role })
  return response.data
}

// Edita el perfil de OTRO usuario (nombre y/o rol) — el CRUD que faltaba:
// antes solo se podía fijar el rol al crear la cuenta, no cambiarlo después.
export const updateUser = async (id: number, changes: { name?: string; role?: UserRole }): Promise<ApiResponse<AuthUser>> => {
  const response = await api.put<ApiResponse<AuthUser>>(`/auth/users/${id}`, changes)
  return response.data
}

export const deleteUser = async (id: number): Promise<ApiResponse<null>> => {
  const response = await api.delete<ApiResponse<null>>(`/auth/users/${id}`)
  return response.data
}

// Restablece la contraseña de OTRO usuario sin conocer la actual — para
// cuando alguien del equipo la olvida y no hay recuperación por email.
export const resetUserPassword = async (id: number, newPassword: string): Promise<ApiResponse<null>> => {
  const response = await api.put<ApiResponse<null>>(`/auth/users/${id}/password`, { newPassword })
  return response.data
}
